export const ImportStatus = {
    PENDING: 'PENDING',
    VALIDATED: 'VALIDATED',
    APPLYING: 'APPLYING',
    APPLIED: 'APPLIED',
    FAILED: 'FAILED',
    CANCELLED: 'CANCELLED',
};
/** Значення в порядку оголошення в схемі. */
export const IMPORT_STATUS_VALUES = ['PENDING', 'VALIDATED', 'APPLYING', 'APPLIED', 'FAILED', 'CANCELLED'];
export const IMPORT_STATUS_LABELS = {
    PENDING: 'Очікує перевірки',
    VALIDATED: 'Перевірено',
    APPLYING: 'Застосовується',
    APPLIED: 'Застосовано',
    FAILED: 'Помилка',
    CANCELLED: 'Скасовано',
};
export const IMPORT_STATUS_TONES = {
    PENDING: 'neutral',
    VALIDATED: 'info',
    APPLYING: 'info',
    APPLIED: 'success',
    FAILED: 'danger',
    CANCELLED: 'neutral',
};
//# sourceMappingURL=import-status.js.map